

















































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import SheetListTab from "../../components/SheetListTab.vue";
import AlertArea from "../../components/AlertArea.vue";
import { BModal } from 'bootstrap-vue';
import { Sheet, SheetListCondition, RowSpanInfo, Room } from "../../modules/teacher/SheetList"


export interface Data {
  tabNo: number
  condition: SheetListCondition
  sheets: Sheet[]
  totalCount: number
  sheetRowSpanInfos: RowSpanInfo[]
  modalSheet: Sheet
  copy_rooms: Room[]
  select_room_ids: string[]
  errors: string[]
  copyErrors: string[]
  isShow: boolean
  isCopying: boolean
}

export default defineComponent({
  components: {
    "sheet-list-tab": SheetListTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * ref
     ******************************/
    const modalCopyStructureRef = ref<InstanceType<typeof BModal>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      tabNo: 1,
      condition: context.root.$store.state.sheetListCondition,
      sheets: new Array<Sheet>(),
      totalCount: 0,
      sheetRowSpanInfos: new Array<RowSpanInfo>(),
      modalSheet: new Sheet({}),
      copy_rooms: new Array<Room>(),
      select_room_ids: [],
      errors: [],
      copyErrors: [],
      isShow: false,
      isCopying: false,
    });

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/sheet_list?${Common.BuildQuery(state.condition, 'search_sheet')}`).then(response => {
        state.sheets = response.data.sheets.map((x: any) => new Sheet(x));
        state.totalCount = response.data.full_count;

        var sheetRowSpanInfos = [];
        for(var i = 0; i < state.sheets.length; i++){
          var sheet = state.sheets[i];
          if(sheetRowSpanInfos.length == 0 || sheetRowSpanInfos[sheetRowSpanInfos.length - 1].sheet_group_key != sheet.sheet_group_key || sheetRowSpanInfos[sheetRowSpanInfos.length - 1].subject_id != sheet.subject_id){
            sheetRowSpanInfos.push({sheet_id: sheet.id, sheet_group_key: sheet.sheet_group_key, subject_id: sheet.subject_id, count: 1});
          }else{
            sheetRowSpanInfos[sheetRowSpanInfos.length - 1].count++;
          }
        }
        state.sheetRowSpanInfos = sheetRowSpanInfos;

        context.root.$store.commit("setSheetListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * rowspan設定
     ******************************/

    const rowSpan = (sheet: Sheet) => {
      var rowInfo = state.sheetRowSpanInfos.filter(x => x.sheet_id == sheet.id);
      return rowInfo.length > 0 ? rowInfo[0].count : 1;
    }

    /******************************
     * セルのスタイル設定
     ******************************/

    const tdStyle = (sheet: Sheet) => {
      const rowInfo = state.sheetRowSpanInfos.filter(x => x.sheet_id == sheet.id);
      return rowInfo.length > 0 ? {} : {"display": "none"};
    };

    /******************************
     * 行のCSSスタイル設定
     ******************************/

    const trStyle = (sheet: any) => {
      var rowInfo = state.sheetRowSpanInfos.filter(x => x.sheet_group_key == sheet.sheet_group_key && x.subject_id == sheet.subject_id);
      if(rowInfo.length > 0){
        var rowIdx = state.sheetRowSpanInfos.indexOf(rowInfo[0]);
        return rowIdx % 2 == 1 ? {"background-color": "#f2f2f2"} : {};
      }
    };

    /******************************
     * 実施日を画面表示文言にコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('M月') : "-";
    };

    /******************************
     * テストグループを画面表示文言にコンバート
     ******************************/

    const convertRoomName = (set_room_name: string) => {
      if (set_room_name) {
        var room = "";
        set_room_name.split("").forEach(x => {
          room = Common.stringConnection(room, x, ",");
        });
        return room;
      } else {
        return "-";
      }
    };

    /******************************
     * クリアボタン押下
     ******************************/

    const clearCondition = () => {
      state.condition = new SheetListCondition();
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * 試験追加・編集ボタン押下
     ******************************/

    const addSheetClick = () => {
      context.root.$router.push('/teacher_site/sheet_edit').catch(err => {});
    };

    /******************************
     * 問題構造設定ボタン押下
     ******************************/

    const fieldEditClick = (sheet: Sheet) => {
      context.root.$router.push(`/teacher_site/field_edit/${sheet.id}`).catch(err => {});
    };

    /******************************
     * 採点枠設定ボタン押下
     ******************************/

    const fieldPositionClick = (sheet: Sheet) => {
      context.root.$router.push(`/teacher_site/position_edit/${sheet.id}`).catch(err => {});
    };

    /******************************
     * コピーモーダル表示
     ******************************/

    const showCopyModal = async (sheet: Sheet) => {

      state.errors = [];
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      await http.get(`/api/sheet_list/room_list/${sheet.id}`).then(response => {
        state.copy_rooms = response.data.rooms.filter((x: any) => x.room_id != sheet.room_id && x.at_cut_job_count == 0).map((x: any) => new Room(x));
        state.select_room_ids = [];
        state.modalSheet = sheet;
        state.copyErrors = [];
        modalCopyStructureRef.value.show();
      })
      .catch(error=>{
        closeCopyModal();
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
  
      context.root.$store.dispatch("hideOverlay");
    };

    // コピーモーダル閉じる
    const closeCopyModal = () => {
      modalCopyStructureRef.value.hide();
    };

    /******************************
     * コピーOKボタン押下
     ******************************/

    const copyStructure = async () => {

      if(state.isCopying){
        return;
      }

      state.copyErrors = [];

      if(state.select_room_ids.length == 0){
        state.copyErrors.push("コピー先のクラスを選択してください");
        return;
      }

      if(!window.confirm("問題構造・採点枠設定をコピーします。\nコピー先に模範解答・答案画像・採点情報が存在する場合は削除されます。\n実行してよろしいですか？")){
        return;
      }

      state.isCopying = true;
      closeCopyModal();
      context.root.$store.dispatch("showOverlay");

      try {
        await http.post(`/api/sheet_list/copy_structure/${state.modalSheet.id}`, {copy_room_ids: state.select_room_ids});
        alert("コピーが完了しました。");
        reload();
      } catch(error) {
        const response = (error as any).response;
        if(response && response.status == 422){
          state.errors = response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      } finally {
        context.root.$store.dispatch("hideOverlay");
        state.isCopying = false;
      }
    };

    /******************************
     * 答案PDFダウンロード
     ******************************/

    const downloadPdf = async (sheet: Sheet) => {

      if(!window.confirm("PDFをダウンロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.get(`/api/sheet_list/download_pdf/${sheet.id}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/zip' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `${sheet.id}.zip`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          state.errors = errorData.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 公開変更
     ******************************/

    const updateResultImagePubliched = async (sheet: Sheet) => {

      if(!window.confirm(`採点結果画像を${sheet.result_image_published ? '公開' : '非公開に'}します。よろしいですか？`)){
        context.root.$nextTick(() => {
          sheet.result_image_published = !sheet.result_image_published;
        });
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/sheet_list/update_result_image_published/${sheet.id}`, {result_image_published: sheet.result_image_published}).then(() => {
        context.root.$bvToast.toast(`採点結果画像を${sheet.result_image_published ? '公開' : '非公開に'}しました。`, {
          title: "処理完了", 
          solid: true, 
          autoHideDelay: 3000,
        });
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
        context.root.$nextTick(() => {
          sheet.result_image_published = !sheet.result_image_published;
        });
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 画面リロード
     ******************************/

    const reload = () => {
      location.reload();
    };

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      if(context.root.$store.state.sheetListCondition == null){
        state.condition = new SheetListCondition();
        state.condition.nendo = context.root.$store.getters.getCurrentNendo();
      }else{
        state.condition = context.root.$store.state.sheetListCondition;
      }
      await search();
      state.isShow = true;
    });

    return {
      ...toRefs(state),
      modalCopyStructureRef,
      search,
      searchClick,
      rowSpan,
      tdStyle,
      trStyle,
      convertExecDate,
      convertRoomName,
      clearCondition,
      changePage,
      addSheetClick,
      fieldEditClick,
      fieldPositionClick,
      showCopyModal,
      closeCopyModal,
      copyStructure,
      downloadPdf,
      reload,
      updateResultImagePubliched,
    }
  }
});
